import React, { useState } from 'react';
import { api } from '../../shared/api';

export function CalcomTestButton({ agentId }) {
  const [testing, setTesting] = useState(false);
  const [result, setResult] = useState(null);

  const runTest = async () => {
    setTesting(true);
    setResult(null);
    try {
      const res = await api.post(`/elevenlabs/test-calcom/${agentId}`);
      setResult(res);
    } catch (e) {
      setResult({ success: false, steps: [{ step: 'Verbindung', status: 'error', detail: String(e) }] });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="mt-3">
      <button
        onClick={runTest}
        disabled={testing}
        className="w-full px-4 py-2.5 bg-gray-800 text-white text-sm font-medium rounded-lg hover:bg-gray-700 disabled:opacity-50 transition-colors"
        data-testid="test-calcom-btn"
      >
        {testing ? 'Teste Verbindung...' : 'Cal.com Verbindung testen'}
      </button>
      {result && (
        <div className={`mt-3 p-3 rounded-lg text-sm space-y-2 ${result.success ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
          <p className={`font-medium ${result.success ? 'text-green-700' : 'text-red-700'}`}>
            {result.success ? 'Alle Checks bestanden!' : 'Probleme gefunden:'}
          </p>
          {(result.steps || []).map((s, i) => (
            <div key={i} className="flex items-start gap-2 text-xs">
              <span className="flex-shrink-0 mt-0.5">
                {s.status === 'ok' ? '\u2705' : s.status === 'warning' ? '\u26A0\uFE0F' : '\u274C'}
              </span>
              <div>
                <span className="font-medium">{s.step}:</span>{' '}
                <span className={s.status === 'error' ? 'text-red-600' : 'text-gray-600'}>{s.detail}</span>
                {s.event_types && (
                  <div className="mt-1 p-1.5 bg-white rounded text-xs">
                    {s.event_types.map((et) => (
                      <div key={et.id} className="text-gray-500">ID: <strong>{et.id}</strong> — {et.title} ({et.slug})</div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
